import React from 'react';
import { pick } from 'lodash';

import EditorBodyLayout from 'app/developer-v3/layouts/EditorBodyLayout';
import FlowForm from 'app/common/components/FlowForm';
import FormaticConfig from 'app/developer-v3/FormaticConfig';

import { fieldTemplates, FormValues } from './fieldTemplates';

import type { LegacySchema } from 'app/developer-v3/platformSchema/legacy';

type Props = {
  isSaving: boolean;
  isDisabled: boolean;
  legacy: LegacySchema;
  saveLegacy: (legacy: FormValues) => void;
};

type State = {
  formValues: FormValues;
};

class Legacy extends React.Component<Props, State> {
  state = {
    formValues: pick(this.props.legacy, [
      'scriptingSource',
      'subscribeUrl',
      'unsubscribeUrl',
    ]),
  };

  onFormChange = (formValues: FormValues) => {
    this.setState({ formValues });
  };

  onSave = () => {
    this.props.saveLegacy({
      ...this.props.legacy,
      ...this.state.formValues,
    });
  };

  render() {
    const { formValues } = this.state;
    const { isSaving, isDisabled } = this.props;

    return (
      <EditorBodyLayout
        isDisabled={isDisabled}
        isSaving={isSaving}
        onSave={this.onSave}
      >
        <FlowForm
          config={FormaticConfig}
          fields={fieldTemplates}
          isValid={true}
          onChange={this.onFormChange}
          value={formValues}
        />
      </EditorBodyLayout>
    );
  }
}

export default Legacy;
